<template>
  <section
    class="section has-large-spacing-bottom has-large-spacing-top is-centered is-full-width has-background-primary my-6"
    v-if="weHaveExchangeRates && showZESACTA"
  >
    <div class="wp-block-group__inner-container">
      <div class="wp-block-cover aligncenter" style="min-height: 317px">
        <span
          aria-hidden="true"
          class="wp-block-cover__background has-vivid-cyan-blue-background-color has-background-dim-100 has-background-dim"
        ></span>
        <div class="wp-block-cover__inner-container">
          <p class="has-text-align-center has-large-font-size">
            <strong>You can buy the ZESA token from us.</strong>
          </p>

          <p class="has-white-color has-text-color">
            You can buy ZESA tokens from us no matter where you are and pay
            using PayPal. Your token will be instantly delivered to your chosen
            phone number via SMS. A&nbsp;<strong>${{ zesaunits }} ZWL</strong>
            ZESA token will cost you&nbsp;<strong>US${{ zwlToUSD() }}</strong
            >using PayPal
          </p>

          <div
            class="is-layout-flex wp-block-buttons"
            @click="moveToEnterDetails"
          >
            <div
              class="wp-block-button has-custom-width wp-block-button__width-100 has-custom-font-size has-normal-font-size"
            >
              <a
                class="wp-block-button__link has-white-color has-vivid-red-background-color has-text-color has-background wp-element-button"
                style="border-radius: 16px"
                ><strong>Buy ZESA Token Now</strong></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <BuyZESAForm
    :zesaUSDAmount="zesaUSDAmount"
    :zesaZARAmount="zesaZARAmount"
    :zesaunits="zesaunits"
    :showBuyZESAForm="showBuyZESAForm"
    @brokenarrow="sayBrokenArrow"
    @hidezesaform="hideBuyZESAForm"
    @showzesabuyform="doShowZESABuyForm"
  />
</template>

<script>
import BuyZESAForm from "./BuyZESAForm.vue";
export default {
  name: "BuyZESACTA",
  props: ["zesaunits", "showZESACTA"],
  emits: ["brokenarrow", "showzesacta", "hidezesacta"],
  components: {
    BuyZESAForm,
  },
  data() {
    return {
      //State variables
      weHaveExchangeRates: false,
      //Actual data
      billsExchangeRates: null,
      zesaUSDAmount: null,
      zesaZARAmount: null,
      showBuyZESAForm: false,
    };
  },
  mounted() {
    const something = fetch(
      "https://zimpricecheck.com/wp-json/zimpricecheck-bill-payments/1.0.0/bills/bill-exchange-rates",
      {
        method: "POST", // or 'PUT'
        mode: "cors",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          tell_me: "secret",
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        this.billsExchangeRates = data;
        this.weHaveExchangeRates = true;
        return;
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  },
  methods: {
    zwlToRand() {
      this.zesaZARAmount = Number(
        (
          (this.zesaunits * this.billsExchangeRates.zar_exchange_rate) /
          this.billsExchangeRates.usd_exchange
        ).toFixed(2)
      );
      return this.zesaZARAmount;
    },
    zwlToUSD() {
      this.zesaUSDAmount = Number(
        (this.zesaunits / this.billsExchangeRates.usd_exchange).toFixed(2)
      );
      return this.zesaUSDAmount;
    },
    sayBrokenArrow() {
      this.$emit("brokenarrow");
    },
    doShowZESABuyForm() {
      this.showBuyZESAForm = true;
    },
    hideBuyZESAForm() {
      this.showBuyZESAForm = false;
    },
    moveToEnterDetails() {
      this.$emit("hidezesacta");
      this.doShowZESABuyForm();
    },
  },

  watch: {
    zesaunits: function () {
      if (this.billsExchangeRates) {
        //If we have the exchange rate
        if (this.zwlToUSD(this.zesaunits) >= 5) {
          this.$emit("showzesacta");
        } else {
          this.$emit("hidezesacta");
        }
      } else {
        this.$emit("hidezesacta");
      }
    },
  },
};
</script>

<style></style>
